import React, { useEffect, useState } from "react";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import { useHistory, useLocation } from "react-router";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import { logoutPaciente } from "../../../context/Actions/paciente/paciente";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../../global/context/Provider";
import {
  BodyMenu,
  ComboMenu,
  ContainerMenu,
  Image,
  TextTopMenu,
  TopMenu,
} from "./localStyle";
import { Link } from "react-router-dom";
import SocialSidebar from "../SocialSidebar/SocialSidebar";

import isIosNative from "../../../../global/utils/isIosNative";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import { listItems } from "./BuergerMobileFun";
import { isCapWeb } from "global/utils/isCapWeb";
import { Capacitor } from "@capacitor/core";
import "./BurguerMobile.css";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

const BurguerMobile = ({ onCloseBurguerMobile, showBurguerMobile }) => {
  //#region  legacy code
  const {
    pacienteDispatch,
    turnosPacienteDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    tokenDispatch,
    selectDropDownDispatch,
    resetPortalContext,
  } = useContext(PortalContext);
  const autocheckContext = useContext(AutocheckContext);
  const pasoDispatch = autocheckContext ? autocheckContext.pasoDispatch : null;
  // Cambio de contexto
  const { authState, authDispatch, configState, resetGlobalContext } =
    useContext(GlobalContext);
  //#region ------ constants ------
  const imgAvatar = authState.auth.data.paciente?.imagenPerfil;
  const history = useHistory();
  const url = useLocation().pathname;
  const isMobile =
    Capacitor.platform === "ios" || Capacitor.platform === "android";
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  // let notiData = notificacionesState.notificaciones?.data;
  // let notifiacionesNoLeidas = notiData
  //   ? notiData?.filter(
  //       (element) =>
  //         !element.fechavisto || element.fechavisto === "0001-01-01T00:00:00"
  //     )
  //   : [];
  const autorizado = sessionStorage.getItem("claveVerificada");
  //#endregion ------ constants ------

  //#region ------ useState ------
  const [itemSelected, setItemSelected] = useState({ 0: 0 });
  const [renderedItems, setRenderedItems] = useState(null);
  //#endregion --- useState ------

  //#region --------- functions ------
  const onHandleSalir = () => {
    // if (authState.authTraza.data !== null) {
    //   wsPostLogoutTraza(authState.authTraza.data.id, {
    //     ingreso: false,
    //     sector: configState.config.data.sectorTurno,
    //   })(authDispatch);
    // }
    if (configState.config.data.opcResetContext) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("idApp");
      localStorage.removeItem("idPaciente");
      resetGlobalContext(0);
      resetPortalContext(0);
      history.push("/");
    } else {
      logoutApp(history)(authDispatch);
      logoutPaciente(history)(pacienteDispatch);
      tokenLogout(history)(tokenDispatch);
      resetTurnosPaciente()(turnosPacienteDispatch);
      resetLaboGrupo()(laboGrupoDispatch);
      resetEstudioGrupo()(estudioGrupoDispatch);
      resetListaFamiliares()(listaFamiliaresDispatch);
      resetDropdown()(selectDropDownDispatch);
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("idApp");
      localStorage.removeItem("idPaciente");
      sessionStorage.token = "";
      sessionStorage.auth = "";
    }
  };

  const navigate = (path) => {
    if (url === "/autocheckin" && path.link === "/autocheckin") {
      setPaso("Home")(pasoDispatch);
    } else {
      history.push(path.link);
    }
  };
  //#endregion --------- functions ------

  //#region ------ useEffect ------
  useEffect(() => {
    if (renderedItems !== null) {
      renderedItems.contents.map((content, index1) => {
        content.map((item, index2) => {
          const element = item;
          if (element.link === url) {
            setItemSelected({ [index1]: index2 });
          }
        });
      });
    }
    let cursor = false;
    let cursory = false;

    window.ontouchstart = (e) => {
      cursor = e.changedTouches[0].clientX;
      cursory = e.changedTouches[0].clientY;
    };

    window.ontouchend = (e) => {
      cursor = cursor - e.changedTouches[0].clientX;
      cursory = cursory - e.changedTouches[0].clientY;
      // if(cursor < 0) onCloseBurguerMobile();
      if (cursor > 0 && cursory < 20 && cursory > -20) {
        // onCloseBurguerMobile("open");
      } else if (cursor < 0 && cursory < 20 && cursory > -20) {
        onCloseBurguerMobile();
      }
    };
  }, []);

  useEffect(() => {
    if (renderedItems === null) {
      setRenderedItems(listItems(setItemSelected, url, autorizado));
    }
  }, [renderedItems]);

  useEffect(() => {
    if (autorizado) {
      setRenderedItems(listItems(setItemSelected, url, autorizado));
    }
  }, [autorizado]);
  //#endregion ------ useEffect ------

  return (
    <React.Fragment>
      <ContainerMenu
        $showBurguerMobile={showBurguerMobile}
        id={"ptur-burguerMobile-0706"}
      >
        <div onClick={onCloseBurguerMobile} className="fondo-abm" />
        {/* ZONA DEL LA IMAGEN DE TOP */}
        <TopMenu $isIos={iosInfo}>
          <div className="cruz-nueva-mitad" onClick={onCloseBurguerMobile}>
            X
          </div>
          <div className="texto-mitad">
            <Image
              id="PerfilImage"
              alt="Perfil"
              src={
                imgAvatar
                  ? `data:image/jpeg;base64,${imgAvatar}`
                  : defaultPerfil
              }
            />
            <TextTopMenu>
              <p className="c-white rb16m">
                {authState.auth.data.paciente.nombre}
              </p>
            </TextTopMenu>
          </div>
        </TopMenu>
        {/* ZONA DEL LISTADO DE LOS ITEM */}
        <BodyMenu>
          <div>
            {renderedItems !== null &&
              renderedItems.contents.map((content, index1) => {
                return (
                  <ComboMenu key={index1}>
                    <h1>{renderedItems.titles[index1]}</h1>
                    <div className="line-white"></div>
                    <ul>
                      {content
                        .filter(
                          (item) =>
                            !(!isMobile && item.link === "/segundofactor")
                        )
                        .map((item, index2) => {
                          const elementActive = Number.isInteger(
                            itemSelected[index1]
                          )
                            ? itemSelected[index1] === index2
                            : false;
                          return (
                            <li
                              key={index2}
                              className={elementActive ? "selected" : ""}
                              onClick={() => {
                                if (item.link === "/") {
                                  onHandleSalir();
                                }
                                if (item.link === "*ayuda*") {
                                  item.fun();
                                }
                              }}
                            >
                              <Link
                                to={item.link === "*ayuda*" ? url : item.link}
                                onClick={() => navigate(item)}
                              >
                                {item.icon}
                                <span>{item.title}</span>
                              </Link>
                            </li>
                          );
                        })}
                    </ul>
                  </ComboMenu>
                );
              })}
          </div>
          {/* Redes sociales */}
          <SocialSidebar
            colorLink={"#fff"}
            cssCustom={"ptur-socialSidebar-burguer"}
          />
          {iosInfo ? (
            <div className="ptur-burguerMobile-bottomFixIos"></div>
          ) : (
            ""
          )}
          {isCapWeb() ? (
            <div className="ptur-burguerMobile-bottomFixWebMobile"></div>
          ) : (
            ""
          )}
        </BodyMenu>
      </ContainerMenu>
    </React.Fragment>
  );
};

export default BurguerMobile;
